import { roundToThousandths } from "../numbers.js";
import { assertNever } from "../type-witchcraft.js";
// NOTE that this function takes trimNormalized into account. Make sure not to
// apply trimNormalized to the duration returned by this function or it will be
// trimmed twice.
export function getTrimmedClipDurationInSeconds(clip) {
    const clipType = clip.type;
    if (clipType === "photo") {
        return clip.durationSeconds;
    }
    else if (clipType === "video") {
        // JS floating point arithmetic can cause off-by-one issues when making
        // these calculations. Rounding will produce reasonable values.
        return roundToThousandths(clip.durationSeconds *
            (clip.trimNormalized.end - clip.trimNormalized.start));
    }
    else {
        assertNever(clipType);
    }
}
